import React from 'react';
import UspComponentT2MobileExterior from './usp-component-t2-mobile-exterior';
import UspComponentT2MobileInterior from './usp-component-t2-mobile-interior';
import { connect } from 'react-redux';
import { setIncrementClicked, setDecrementClicked, setToggleHotspotView, setIncrementClickedInterior, setDecrementClickedInterior, setToggleInteriorHotspot, setInteriorHotspotIndex, setHotspotClickedIndex } from '../../../Redux/Reducers/View360Reducer/View360ActionController'

const UspComponentT2Mobile = (props) => {
  return (
    <>
      {/* Exterior Hotspots Component */}
      <UspComponentT2MobileExterior {...props} />
      
      {/* Interior Hotspots Component */}
      <UspComponentT2MobileInterior {...props} />
    </>
  );
};

const mapStateToProps = (state) => ({
  incrementClicked: state.view360Reducer.incrementClicked,
  decrementClicked: state.view360Reducer.decrementClicked,
  incrementClickedInterior: state.view360Reducer.incrementClickedInterior,
  decrementClickedInterior: state.view360Reducer.decrementClickedInterior,
  toggleInteriorHotspots: state.view360Reducer.toggleInteriorHotspots,
  interiorHotspotIndex: state.view360Reducer.interiorHotspotIndex,
  hotspotClickedIndex: state.view360Reducer.hotspotClickedIndex,
  toggleHotspotView: state.view360Reducer.toggleHotspotView
});

const mapDispatchToProps = {
  setIncrementClicked,
  setDecrementClicked,
  setToggleHotspotView,
  setIncrementClickedInterior,
  setDecrementClickedInterior,
  setToggleInteriorHotspot,
  setInteriorHotspotIndex,
  setHotspotClickedIndex
};

export default connect(mapStateToProps, mapDispatchToProps)(UspComponentT2Mobile);